import { useState, useEffect } from 'react';
import generalController from '../controllers/generalController';

export const useMediaQuery = () => {
  const [mediaQuery, setMediaQuery] = useState(generalController.getMediaQuery());

  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId = null;

    const handleWindowResize = () => {
      // Prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      // Run after 150 milliseconds.
      timeoutId = setTimeout(() => {
        setMediaQuery(generalController.getMediaQuery());
      }, 150);
    }

    // Set resize listener
    window.addEventListener("resize", handleWindowResize);
    // Remove resize listener
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  // Return both the height and width
  return mediaQuery;
}